<script lang="ts">
import { defineComponent } from 'vue';
import { number, string } from 'vue-types';
import { Progress } from 'ant-design-vue';

import HarmonLogo from '@/ui/Svg/HarmonLogo.vue';

export default defineComponent({
  name: 'StartLogo',
  components: {
    HarmonLogo,
    Progress,
  },
  props: {
    text: string(),
    percent: number(),
  },
});
</script>

<template>
  <div
    class="absolute w-full h-full px-4 flex flex-col items-center dark:bg-gray-900"
  >
    <div class="w-full max-w-sm">
      <div class="h-36 mt-36 mb-4">
        <HarmonLogo />
      </div>
      <Progress
        v-if="percent"
        :percent="percent"
        status="active"
        :show-info="false"
      />
      <div v-if="text" class="text-center opacity-50">
        {{ text }}
      </div>
    </div>
  </div>
</template>
